import React from 'react';
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import config from '../../config.js'
import photo_peter from '../../images/Polymedia-Peter_van_der_Meer.jpg'
import icon_fb from '../../images/facebook-dieetclub-dieetpuntclub.png'
import icon_li from '../../images/linkedin-dieetclub-dieetpuntclub.png'

import {setMetatags} from '../../modules/metatag_functions.js'
import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'


class Recipe extends React.Component {

  constructor(props) {
    super(props);

    let ref_id = false;
    let recipe_path = this.props.pathname.replace("/recept/", "");
    if(recipe_path !== "" && recipe_path !== "/recept") {
      let splitted = recipe_path.split("-");
      if(splitted.length > 0) {
        ref_id = splitted.pop();
      }
    } else {
      this.props.push("/recepten");
    }

    this.state = {ref_id};
  }

  componentWillMount() {
    if(this.state.ref_id) {
      let {ref_id} = this.state;
      if(this.props.session_token) {
        this.props.fetchDataIfReady(config.api_token, "recipe_"+ref_id, "GET", config.api_url+"/recipe?ref_id="+ref_id+"&t="+this.props.session_token);
      } else {
        this.props.fetchDataIfReady(config.api_token, "recipe_"+ref_id, "GET", config.api_url+"/recipe?ref_id="+ref_id);
      }
    }
  }

  render() {
    let {ref_id} = this.state;
    let recipe_card = null, recipe_data = this.props.apiData["recipe_"+ref_id], recipe_jsonld = null;

    let has_data = recipe_data !== undefined && recipe_data.data !== undefined && recipe_data.data !== null && recipe_data.data.ref_id !== undefined;
    if(has_data) {
      let recipe = recipe_data.data;
      let cd = new Date(recipe.created_at);
      let cd_txt = cd.getDate()+" "+cd.toLocaleString('default', { month: 'long' })+" "+cd.getFullYear();
      let cd_time = <time dateTime={cd.getFullYear()+"-"+(cd.getMonth()+1)+"-"+cd.getDate()}>{cd_txt}</time>;
      let ud = new Date(recipe.updated_at);
      let ud_txt = ud.getDate()+" "+ud.toLocaleString('default', { month: 'long' })+" "+ud.getFullYear();
      let ud_time = <time dateTime={ud.getFullYear()+"-"+(ud.getMonth()+1)+"-"+ud.getDate()}>{ud_txt}</time>;

      let author_card = null;
      if(true) { // net als original_publisher nog checks van maken :)
        author_card = <div className="card">
          <div style={{display:"inline-block", width:"15%"}}><div className="image-container"><img src={photo_peter} alt={"Dieet.Club | Peter van der Meer"} style={{maxWidth:"100px", maxHeight:"100px", borderRadius:"16px"}} /></div></div>
          <div style={{display:"inline-block", width:"85%", paddingLeft:"7px", verticalAlign:"top"}}><h2 style={{margin:".1em 0"}}>Peter van der Meer</h2><p style={{fontSize:"85%"}}>Ontwikkelaar Dieet.Club, ik schrijf over van alles wat me interesseert. Momenteel eet ik veel koolhydraatarm, en met Intermittent Fasting eet ik enkel tussen 12 en 7. Daarnaast fitness ik drie keer per week, voornamelijk krachttraining, en loop ik graag.</p><div style={{marginTop:".7em"}}><a href="https://www.facebook.com/DieetPuntClub/" target="_blank" rel="noopener noreferrer"><img src={icon_fb} alt="Facebook" style={{background:"#000", borderRadius:"3px", width:"24px", marginRight:"3px"}} /></a><a href="https://www.linkedin.com/in/peterdotplus" target="_blank" rel="noopener noreferrer"><img src={icon_li} alt="Li" style={{background:"#000", borderRadius:"3px", width:"24px", marginRight:"3px"}} /></a></div></div>
        </div>;
      }
      let disclaimer_card = <div style={{border:"3px solid #555", padding:".8em"}}>Dieet.Club bevat informatie en entertainment over gezondheid en gerelateerde onderwerpen. De informatie, andere inhoud en gelinkte onderdelen zijn niet bedoeld als medisch advies. Geen enkele inhoud op deze website moet gebruikt worden als alternatief voor direct medisch advies van jouw huisarts of een vergelijkbare behandelaar.</div>;

      let original_link_txt = "";
      if(recipe.original_link) {
        original_link_txt = recipe.original_link.replace("https://", "").replace("http://", "").replace("www.", "");
        original_link_txt = original_link_txt.split("/")[0];
      }

      // todo: author DC of user? en bij original link? (bij Club user, voor nu DC)
      recipe_jsonld = JSON.parse(recipe.json);
      recipe_jsonld["@context"] = "https://schema.org";
      recipe_jsonld["@type"] = "Recipe";
      recipe_jsonld["author"] = {"@type":"Organization", "name":"Dieet.Club", "url":"https://dieet.club"};
      recipe_jsonld["name"] = recipe.title;
      recipe_jsonld["image"] = "https://images.dieet.club/"+recipe.img_fn;
      recipe_jsonld["datePublished"] = recipe.created_at;
      if(recipe_jsonld["recipeInstructions"]) recipe_jsonld["recipeInstructions"][0]["name"] = "Ingrediënten";

      let recipe_core = null;
      if(recipe_jsonld["recipeInstructions"] && recipe_jsonld["recipeIngredient"]) {
        let ingredients_list = [];
        for(let i = 0; i < recipe_jsonld["recipeIngredient"].length; i++) {
          ingredients_list.push(<li key={"ing"+i} style={{lineHeight:"2"}}>{recipe_jsonld["recipeIngredient"][i]}</li>);
        }
        let instructions_list = [];
        for(let i = 0; i < recipe_jsonld["recipeInstructions"].length; i++) {
          if(!recipe_jsonld["recipeInstructions"][0]["itemListElement"]) {
            instructions_list.push(<li key={"ins"+i}>{recipe_jsonld["recipeInstructions"][i].text}</li>);
          } else {
            for(let i2 = 0; i2 < recipe_jsonld["recipeInstructions"][0]["itemListElement"].length; i2++) {
              instructions_list.push(<li key={"ins"+i2}>{recipe_jsonld["recipeInstructions"][0]["itemListElement"][i2].text}</li>);
            }
          }
        }
        recipe_core = <div style={{margin:"2em 0 0"}}>
          <div className="col-4" style={{padding:"1em 1em 1.5em", marginBottom:"1em", background:"#000", color:"#fff", borderRadius:"7px"}}><h2 style={{margin:".4em 0 0"}}>Ingrediënten</h2>{recipe_jsonld["recipeYield"] && <p style={{fontSize:"110%"}}>{recipe_jsonld["recipeYield"]}</p>}<ul style={{marginTop:"12px"}}>{ingredients_list}</ul></div>
          <div className="col-3-4" style={{padding:"0 2em 1em", marginBottom:"1em"}}><h2 style={{margin:"0 0 .4em"}}>Stappen</h2><ol>{instructions_list}</ol></div>
        </div>;
      }

      let recipe_totalTime = (recipe_jsonld["totalTime"]) ? this.durationTxt(recipe_jsonld["totalTime"]) : null;
      let recipe_prepTime = (recipe_jsonld["prepTime"]) ? this.durationTxt(recipe_jsonld["prepTime"]) : null;
      let recipe_cookTime = (recipe_jsonld["cookTime"]) ? this.durationTxt(recipe_jsonld["cookTime"]) : null;
      let recipe_keywords = null;
      if(recipe_jsonld["keywords"]) {
        recipe_keywords = [];
        let kw = recipe_jsonld["keywords"].split(",");
        for(let i = 0; i < kw.length; i++) {
          recipe_keywords.push(<span key={"kw"+i} className="contact-label" style={{background:"transparent", color:"#000", border:"2px solid #000"}}>{kw[i].trim()}</span>);
        }
      }
      let recipe_cuisine = null; // todo whn: (test) styling if both _keywords and _cuisine (and _category) are used.
      if(recipe_jsonld["recipeCuisine"]) {
        recipe_cuisine = <span className="contact-label" style={{background:"transparent", color:"#000", border:"2px solid #000"}}>{recipe_jsonld["recipeCuisine"]}</span>;
      }

      recipe_card = <div className="col-1"><div className="card">
        <div className="image-container"><img src={"https://images.dieet.club/"+recipe.img_fn} alt={"Dieet.Club | "+recipe.title} /></div>
        <h1 style={{marginTop:"1rem"}}>{recipe.title}</h1>
        {recipe.original_link && <small style={{opacity:".5", display:"block", fontSize:"75%"}}>Origineel gepubliceerd door <a href={recipe.original_link} target="_blank" style={{color:"#444"}}>{original_link_txt}</a></small>}
        <div style={{marginTop:"1em"}}>
          <div className="col-2">
            {recipe_totalTime && <p>totaal: {recipe_totalTime}</p>}
            {recipe_prepTime && <p>bereiden: {recipe_prepTime}</p>}
            {recipe_cookTime && <p>koken: {recipe_cookTime}</p>}
            {recipe_jsonld["nutrition"] && recipe_jsonld["nutrition"]["calories"] && <p>energie: {recipe_jsonld["nutrition"]["calories"]}</p>}
          </div>
          <div className="col-2" style={{textAlign:"right"}}>
            {recipe_cuisine && <div>{recipe_cuisine}</div>}
            {recipe_keywords && <div>{recipe_keywords}</div>}
          </div>
        </div>
        {recipe_core}
        {recipe_jsonld["description"] && <div style={{marginTop:"5em"}}><h2 style={{margin:".4em 0"}}>Beschrijving</h2><p>{recipe_jsonld["description"]}</p></div>}
        <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right", marginTop:"3em"}} title={recipe.created_at}>Gepubliceerd: {cd_time}</small>
        {(recipe.created_at !== recipe.updated_at) && <small style={{opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}} title={recipe.updated_at}>Laatst aangepast: {ud_time}</small>}
      </div>{author_card}{disclaimer_card}</div>;

      let meta_description = "";
      if(recipe_jsonld["recipeInstructions"]) {
        for(let i = 0; i < recipe_jsonld["recipeInstructions"].length; i++) {
          if(!recipe_jsonld["recipeInstructions"][0]["itemListElement"]) {
            meta_description += "Stap "+(i+1)+": "+recipe_jsonld["recipeInstructions"][i].text+" ";
          } else {
            for(let i2 = 0; i2 < recipe_jsonld["recipeInstructions"][0]["itemListElement"].length; i2++) {
              meta_description += "Stap "+(i2+1)+": "+recipe_jsonld["recipeInstructions"][0]["itemListElement"][i2].text+" ";
            }
          }
        }
      }
      setMetatags(recipe.title+" | Recept Peter van der Meer", meta_description, "https://images.dieet.club/"+recipe.img_fn, "article", this.props.pathname, recipe.updated_at);
    }

    return (
      <div className="container content" style={{marginTop:"3em", marginBottom:"3em"}}>
        {has_data && <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(recipe_jsonld)}} />}
        {has_data && recipe_card}
      </div>
    );
  }


  durationTxt(iso8601Duration) {
    let duration_txt = "";
    let duration = this.parseISO8601Duration(iso8601Duration);
    if(duration.days && duration.days > 0) duration_txt += duration.days+" dag(en) ";
    if(duration.hours && duration.hours > 0) duration_txt += duration.hours+" uur ";
    if(duration.minutes && duration.minutes > 0) duration_txt += duration.minutes+" min. ";
    if(duration.seconds && duration.seconds > 0) duration_txt += duration.seconds+" sec. ";
    return duration_txt;
  }

  parseISO8601Duration(iso8601Duration) {
    var iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
    var matches = iso8601Duration.match(iso8601DurationRegex);
    return {
        sign: matches[1] === undefined ? '+' : '-',
        years: matches[2] === undefined ? 0 : matches[2],
        months: matches[3] === undefined ? 0 : matches[3],
        weeks: matches[4] === undefined ? 0 : matches[4],
        days: matches[5] === undefined ? 0 : matches[5],
        hours: matches[6] === undefined ? 0 : matches[6],
        minutes: matches[7] === undefined ? 0 : matches[7],
        seconds: matches[8] === undefined ? 0 : matches[8]
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Recipe)



// WEBPACK FOOTER //
// ./src/containers/StartPages/Recipe.js